/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type TemplateDetailsColumnQueryVariables = {
    templateId: string;
};
export type TemplateDetailsColumnQueryResponse = {
    readonly node: {
        readonly id: string;
        readonly props?: unknown | null;
    } | null;
};
export type TemplateDetailsColumnQuery = {
    readonly response: TemplateDetailsColumnQueryResponse;
    readonly variables: TemplateDetailsColumnQueryVariables;
};



/*
query TemplateDetailsColumnQuery(
  $templateId: ID!
) {
  node(id: $templateId) {
    __typename
    id
    ... on DocumentTemplate {
      props
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "templateId"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "templateId"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "props",
                "storageKey": null
            }
        ],
        "type": "DocumentTemplate",
        "abstractKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "TemplateDetailsColumnQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v3 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "RootQueryType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "TemplateDetailsColumnQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                        },
                        (v2 /*: any*/),
                        (v3 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "c40fa4f562be6338b28698e030d825ba",
            "id": null,
            "metadata": {},
            "name": "TemplateDetailsColumnQuery",
            "operationKind": "query",
            "text": "query TemplateDetailsColumnQuery(\n  $templateId: ID!\n) {\n  node(id: $templateId) {\n    __typename\n    id\n    ... on DocumentTemplate {\n      props\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '2210ac21b37993c3e2b5f1cd1ec5d530';
export default node;
